// Full page load: after sign-in the app restarts with the stored current user.
export function redirectTo(url: string): void {
    window.location.href = url;
}
